import { Box, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { authService } from '@/services/authService';
import { NotAvailable } from '@/pages/NotAvailable';

export function PortalAvailabilityGate({ children }: Readonly<{ children: ReactNode }>) {
  const { data, isLoading } = useQuery({
    queryKey: ['adminPortalStatus'],
    queryFn: authService.getStatus,
    staleTime: 60_000,
    retry: false,
  });

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={40} aria-label="Loading" />
      </Box>
    );
  }

  // Fail open on network errors so an API outage still shows the login form;
  // Login POST re-checks ConnectAdminPortalEnabled server-side.
  if (data?.enabled === false) {
    return <NotAvailable />;
  }

  return children;
}
